import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { getsJoomlaMenu } from "../actions/menu";
import menuIcon from "../images/menu_left_icon.svg";
import logo from "../images/logo.png";
import logoSmall from "../images/logo-small.png";
import JoomlaOffcanvasMenu from "./joomlaOffcanvasMenu";
import WishBar from "./wishCartCompareBar";
import Menu from "./menu";
import i18n from "i18next";
import { Link, withRouter } from "react-router-dom";
import { config } from "../config";
import catalogIcon from "../images/catalog-icon.svg";
import MobMenu from "./mobMenu";
import FlagUa from "../images/flag-ua.png";
import FlagRu from "../images/flag-ru.png";
import TopNavMenu from "./Topbar/joomlaMenu";
import LanguageSwitcher from "./Topbar/language";
import searchIcon from "../images/search_icon.svg";
import Search from "./search";
import NavBar from "./navBar";
import UIkit from "uikit";
class Topmenu extends Component {
  static props = {
    joomlaMenu: PropTypes.array,
    isShowLoaderMenu: PropTypes.bool,
  };

  /**
   *
   */
  componentDidMount() {
    // this.props.getsJoomlaMenu();
  }

  button = (lang, flagImg) => {
    return (
      <div
        className={
          i18n.language === lang
            ? "header-lang uk-display-inline-block active"
            : "header-lang uk-display-inline-block non-active"
        }
        id={lang}
        onClick={() => {
          var regex = new RegExp("(?<=product?.\\/)(.*?)(?=\\/)", "m");
          var newLink =
            this.props.location.pathname + this.props.location.search;
          var replaced = newLink.replace(regex, lang);
          if (i18n.language !== lang) {
            window.location.href = replaced;
          }
        }}
        title={lang}
      >
        <img src={flagImg} alt={lang} />
      </div>
    );
  };

  render() {
    const { t } = this.props;
    return (
      <>
        <header>
          <div className="mob-header uk-hidden@m">
            <div className="uk-container">
              <div className="mob-header__body uk-flex uk-flex-middle uk-flex-between">
                <div className="uk-flex uk-flex-middle uk-flex-between">
                  <div className="uk-margin-small-right">
                    <div uk-toggle="target: #offcanvas-menu">
                      <img
                        className="mob-header__menu-btn"
                        src={menuIcon}
                        uk-svg=""
                      />
                    </div>
                  </div>
                  <div>
                    <a href="/">
                      <img className="mob-header__logo" src={logoSmall} />
                    </a>
                  </div>
                  <JoomlaOffcanvasMenu location={this.props.location} />
                </div>
                <div className="uk-flex uk-flex-middle uk-flex-right">
                  <div className="uk-margin-right" onClick={(e)=>{
                    UIkit.modal("#modal-search").show();
                  }}>
                    <img className="mob-header__search-btn" src={searchIcon} />
                  </div>
                  <div id="modal-search" className="uk-flex-top" uk-modal="">
                      <div className="uk-modal-dialog uk-modal-body uk-padding-small">
                      {/* <button className="mob-header__modal-close uk-modal-close-default" type="button" uk-close=""></button> */}
                      <Search history={this.props.history} location={this.props.location} isMobile={true}/>
                      </div>
                  </div>
                  <WishBar />
                </div>
              </div>
            </div>
          </div>
          <div className="uk-visible@m">
            {/* <div className="header-top-bar uk-background-muted">
              <div className="uk-container">
                <div className="uk-flex uk-flex-middle uk-flex-between">
                  <TopNavMenu />
                  <LanguageSwitcher location={this.props.location} />
                </div>
              </div>
              
            </div> */}
            <div className="uk-container">
                <div className="header-middle-block uk-flex uk-flex-middle uk-flex-between">
                  <div className="uk-width-1-4">
                    <a href="/">
                      <img
                        className="header__logo"
                        src={logo}
                        alt={t("shop.name")}
                      />
                    </a>
                  </div>
                  <div className="uk-width-1-2 uk-margin-left ">
                    <Search history={this.props.history} location={this.props.location} isMobile={false}/>
                  </div>
                  <div className="uk-width-1-5 uk-text-right">
                        <span className="uk-text-muted uk-text-small">{t("shop.client_service")}</span>
                        <div>
                            <a className="uk-text-secondary uk-text-large uk-text-bold" href="tel:+380500107128">(050)-010-71-28</a>
                        </div>
                    </div>
                </div>
              </div>
              <NavBar/>
          </div>
        </header>

        {/* <div className="header uk-hidden">
          <div className="header-info">
            <div className="uk-container uk-container-large uk-flex uk-flex-middle uk-flex-between ">
              <div>
                <div className="uk-navbar-left uk-visible@m ">
                  <img
                    className="header__logo"
                    src={logo}
                    alt={t("shop.name")}
                  />
                  <ul className="uk-navbar-nav uk-margin-large-left">
                    {this.props.isShowLoaderMenu === false
                      ? Object.keys(this.props.joomlaMenu.joomla).map(
                          (itm, key) => (
                            <li key={"jom-menu-" + itm}>
                              <a
                                className="header-nav__link"
                                href={
                                  config.siteUrl +
                                  this.props.joomlaMenu.joomla[itm].alias
                                }
                              >
                                {this.props.joomlaMenu.joomla[itm].title}
                              </a>
                            </li>
                          )
                        )
                      : ""}
                  </ul>
                </div>
              </div>

              <div className={"uk-visible@m"}>
                <ul className="uk-list uk-link-text uk-margin-remove">
                  <li>
                    <a className="uk-text-small" href="tel:+380504079997">
                      <span itemProp="telephone">+38(050)407-99-97</span>
                    </a>
                  </li>
                  <li>
                    <a className="uk-text-small" href="tel:+38067545-18-38">
                      <span itemProp="telephone">+38(067)545-18-38</span>
                    </a>
                  </li>
                </ul>
              </div>

              <div className="header-nav__lang-btn uk-flex">
                <div className="uk-margin-right uk-visible@m">
                  {this.button("ua", FlagUa)}
                  {this.button("ru", FlagRu)}
                </div>

                <WishBar />
              </div>
            </div>
          </div>
          <div className="header-wrap uk-width-1-1">
            <div className="header-nav-wrap uk-padding-small uk-container uk-container-large"> */}
              {/* <div className="uk-hidden@m" uk-toggle="target: #offcanvas-menu">
                <img
                  className="header-nav-mb__btn-menu"
                  src={menuIcon}
                  uk-svg=""
                  alt={"menu"}
                />
              </div> */}
              {/* <nav
                className="uk-navbar-container uk-width-1-1 uk-visible@m"
                uk-navbar=""
              >
                <a href="#" className="uk-width-small uk-hidden">
                  <img
                    className="header-nav-mb__logo"
                    src={logo}
                    alt={t("shop.name")}
                  />
                </a>
                <Menu />
              </nav>
            </div>
            <JoomlaOffcanvasMenu />
          </div>
        </div>
        <div className="catalog-menu__mb-btn uk-hidden@m  uk-margin-bottom uk-padding-small">
          <div uk-toggle="target: #offcanvas-mob-menu">
            <img
              className="catalog-menu__mb-icon"
              src={catalogIcon}
              uk-svg={""}
              alt={t("menu.catalog")}
            />{" "}
            catalog
          </div>
          <div id="offcanvas-mob-menu" uk-offcanvas="overlay: true">
            <div className="uk-offcanvas-bar">
              <MobMenu />
            </div>
          </div>
        </div> */}
      </>
    );
  }
}

const mapStateToProps = (store) => {
  const { joomlaMenu, isShowLoaderMenu } = store.menu;
  return { joomlaMenu, isShowLoaderMenu };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getsJoomlaMenu: () => {
      dispatch(getsJoomlaMenu());
    },
  };
};

const HighMenu = withTranslation("translations")(Topmenu);
const JoomlaMenu = withRouter(HighMenu);
export default connect(mapStateToProps, mapDispatchToProps)(JoomlaMenu);
